import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { useCallback } from 'react';
export function useOnObjectsUpdated() {
  const sendUpdateObjectsMessage = useSendCrmMessageTopic(TOPIC_NAMES.UPDATE_OBJECTS);
  return useCallback((result, objectTypeId) => {
    const messageBusPayload = Object.keys(result).map(id => ({
      objectId: id,
      objectTypeId,
      propertyNames: Object.keys(result[id] || {})
    }));
    sendUpdateObjectsMessage(messageBusPayload, {
      sourceId: 'customer-data-properties'
    });
  }, [sendUpdateObjectsMessage]);
}